import { useBookmakersAll } from './useBookmakersAll';

export const useOffersSignUpAllCount = () => {
  const bookmakers = useBookmakersAll();

  return bookmakers.reduce((total, cur) => total + (cur.offers.signupOffers || []).length, 0);
};
